import { render, staticRenderFns } from "./PropertyListsOwner.vue?vue&type=template&id=0a211448&scoped=true&"
import script from "./PropertyListsOwner.vue?vue&type=script&lang=js&"
export * from "./PropertyListsOwner.vue?vue&type=script&lang=js&"
import style0 from "./PropertyListsOwner.vue?vue&type=style&index=0&id=0a211448&prod&lang=scss&scoped=true&"
import style1 from "./PropertyListsOwner.vue?vue&type=style&index=1&id=0a211448&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a211448",
  null
  
)

export default component.exports